import { render, staticRenderFns } from "./movementForm.vue?vue&type=template&id=72ee4ea5"
import script from "./movementForm.vue?vue&type=script&lang=js"
export * from "./movementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports